var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickspin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 542,
    height: 542,
    viewBox: "0 0 542 542",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_348_3251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 100C0 44.7715 44.7715 0 100 0H442C497.228 0 542 44.7715 542 100V442C542 497.228 497.228 542 442 542H100C44.7715 542 0 497.228 0 442V100Z",
    fill: "#FA5A0C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.511 446.822C307.711 465.17 321.21 517.371 357.248 498.912C392.174 481.02 355.13 437.26 346.428 416.558C357.21 399.182 374.086 381.661 373.64 351.49C373.567 346.583 372.722 340.429 371.285 336.576C363.374 315.369 337.407 311.579 322.294 327.119C318.762 330.75 317.09 335.198 315.719 339.47C310.741 354.992 314.411 373.694 290.026 386.032C263.633 399.38 238.007 381.489 231.286 362.494C227.681 352.309 229.637 336.968 221.104 327.15C214.783 319.875 200.679 314.659 184.873 321.885C176.156 325.871 172.392 333.998 170.558 345.086C163.858 385.575 203.663 457.733 294.511 446.822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.89 42.8406C220.699 49.7531 203.777 63.9694 190.372 80.9161C169.52 107.273 167.518 130.094 169.996 146.138C171.291 154.533 175.08 160.363 181.177 164.499C193.293 172.715 212.256 172.53 222.947 160.478C226.617 156.343 229.91 146.069 230.401 139.195C231.711 120.844 240.215 96.7763 271.696 96.279C315.766 95.5818 313.158 126.749 315.71 148.829C316.44 155.157 320.466 160.29 325.487 164.119C333.823 170.441 344.23 171.412 351.203 170.018C359.626 168.335 368.566 161.261 371.98 151.879C374.993 143.593 374.319 133.471 372.014 121.392C362.571 71.9598 308.574 28.9437 249.89 42.8406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.719 310.429C332.36 298.021 356.465 297.926 373.144 310.45L373.182 177.666C352.721 191.827 333.105 190.13 313.594 177.666L313.719 310.429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.659 310.648C182.064 297.962 211.854 296.674 227.408 310.236L228.369 179.126C215.932 185.247 213.072 187.541 200.244 187.96C187.19 188.389 178.202 183.452 168.621 178.689L168.659 310.648Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_348_3251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 542,
    height: 542,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickspin);
export default __webpack_public_path__ + "static/media/quickspin.96f2d783a1d1352acf962d3a48670a77.svg";
export { ForwardRef as ReactComponent };